import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatorSortPipe } from './operator-sort.pipe';

@NgModule({
  declarations: [OperatorSortPipe],
  imports: [CommonModule],
  exports: [OperatorSortPipe]
})
export class OperatorSortPipeModule {}
